import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class WebsiteRedirectAddForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      oldSubdomain: [ '', [ Validators.required ] ],
      newSubdomain: [ '', [ Validators.required ] ],
    });
  }
}
